<template>
    <div class="tag-filter">
        <!-- <label class="typo__label">{{ $tc('marker.tags.title') }}</label> -->
        <multiselect
            v-model="value"
            :placeholder="$tc('marker.tags.placeholder')"
            label="name" track-by="name"
            :options="options"
            multiple
            :close-on-select="false"
            :loading="loading"
            hide-selected
            @input="inputHandler"
        >
            <template slot="option" slot-scope="props">
                <div class="option__desc">
                    <span class="option__title">
                        {{ props.option.name }}
                    </span>
                    <span class="option__small">
                        {{ $t('records.records_label') }}: {{ props.option.records }}
                    </span>
                </div>
            </template>
        </multiselect>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import RecordRepository from '../../../repositories/RecordRepository'
import events from '../../../services/events'
import debounce from 'lodash.debounce'

export default {
  components: {
    Multiselect
  },
  props: {
    markerId: {
      type: Number,
      required: false
    }
  },
  mounted () {
    this.fetchTags()
  },

  data: () => ({
    loading: false,
    value: [],
    options: []
  }),
  methods: {
    fetchTags () {
      this.loading = true
      RecordRepository.fetchMarkerRecordTags(this.markerId).then((tags) => {
        this.loading = false
        this.options = this.convertTagsToOptions(tags)
      }, (error) => {
        this.loading = false
        events.emit('error', error)
      })
    },
    convertTagsToOptions (tags) {
      return tags.map(({tag, records}) => {
        return {
          name: tag,
          records
        }
      })
    },
    inputHandler: debounce(function (tags) {
      const tagNames = tags.map(tag => tag.name)
      this.$emit('tags-selected', tagNames)
    }, 350)
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
  @import '../../../assets/css/colors';

  $tag-color: $brand-color-primary;
  .option__desc {
    display: flex;
    justify-content: space-between;
  }
  // redefine default colors of the multiselect component
  .multiselect__option--highlight,
  .multiselect__option--highlight:after,
  .multiselect__tag {
    background: $tag-color;
  }
  .multiselect__tag-icon:after {
    color: $background-color
  }
  .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
    background: $brand-color-shadow;
  }
  .multiselect.multiselect--active {
    z-index: 10000;
  }
</style>
